import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'ProductionFigure',
  //   description: 'description of ProductionFigure',
  //   url: '/production-figure',
  // },
];

export default help;
